module.exports = __webpack_public_path__ + "img/panel_6.ce9411d1.png";